/**
 * Unified Countdown Timers
 * Handles both cart promo (simple) and PDP (full boxes) countdown formats
 */
(function() {
  'use strict';

  var initialized = new WeakSet();

  /* Cart Promo Timer - Simple "Ends Xh Xm" format */
  function initCartTimer(el) {
    if (!el || initialized.has(el)) return;
    initialized.add(el);

    var expiry = new Date((el.dataset.expiry || '').trim());
    if (isNaN(expiry.getTime())) {
      el.textContent = 'Expired';
      return;
    }

    var handle;
    function tick() {
      var dist = expiry.getTime() - Date.now();
      if (dist <= 0) {
        el.textContent = 'Expired';
        if (handle) clearInterval(handle);
        return;
      }
      var h = Math.floor(dist / 3600000);
      var m = Math.floor((dist % 3600000) / 60000);
      el.textContent = 'Ends ' + h + 'h ' + m + 'm';
    }

    tick();
    handle = setInterval(tick, 60000);
  }

  /* PDP Timer - Full DD:HH:MM:SS boxes format */
  function initPdpTimer(container) {
    if (!container || initialized.has(container)) return;
    initialized.add(container);

    var boxesEl = container.querySelector('.countdown-timer__boxes');
    var expiryRaw = container.dataset.countdown;
    if (!boxesEl || !expiryRaw) return;

    var daysEl = boxesEl.querySelector('.countdown-days');
    var hoursEl = boxesEl.querySelector('.countdown-hours');
    var minutesEl = boxesEl.querySelector('.countdown-minutes');
    var secondsEl = boxesEl.querySelector('.countdown-seconds');

    var expiry = new Date(expiryRaw);
    if (isNaN(expiry.getTime())) {
      boxesEl.innerHTML = '<div class="countdown-timer__box"><span class="countdown-timer__value">EXPIRED</span></div>';
      return;
    }

    var handle;
    function tick() {
      var dist = expiry.getTime() - Date.now();
      if (dist <= 0) {
        if (handle) clearInterval(handle);
        boxesEl.innerHTML = '<div class="countdown-timer__box"><span class="countdown-timer__value">EXPIRED</span></div>';
        return;
      }

      var d = Math.floor(dist / 86400000);
      var h = Math.floor((dist % 86400000) / 3600000);
      var m = Math.floor((dist % 3600000) / 60000);
      var s = Math.floor((dist % 60000) / 1000);

      if (dist < 86400000) {
        boxesEl.classList.add('is-subday');
      } else {
        boxesEl.classList.remove('is-subday');
      }

      if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(m).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(s).padStart(2, '0');
    }

    tick();
    handle = setInterval(tick, 1000);
  }

  /* Initialize all timers on page */
  function initAll() {
    document.querySelectorAll('[data-timer-id="cart-promo-timer"]').forEach(initCartTimer);
    document.querySelectorAll('.countdown-timer[data-countdown]').forEach(initPdpTimer);
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Watch for dynamically added timers (cart drawer AJAX, etc.) */
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;

        /* Check if node itself is a timer */
        if (node.matches && node.matches('[data-timer-id="cart-promo-timer"]')) {
          initCartTimer(node);
        } else if (node.matches && node.matches('.countdown-timer[data-countdown]')) {
          initPdpTimer(node);
        }

        /* Check children */
        if (node.querySelectorAll) {
          node.querySelectorAll('[data-timer-id="cart-promo-timer"]').forEach(initCartTimer);
          node.querySelectorAll('.countdown-timer[data-countdown]').forEach(initPdpTimer);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();